import jQuery from 'jquery';

/**
 * Constructor
 *
 * @param {Object} domConfigs
 * @param {Object} target
 * @constructor
 */
function SearchUiDomJQueryBuilder(domConfigs, target) {

    this.domConfigs = domConfigs;
    this.target = target;
}

/**
 * Builds Dom
 */
SearchUiDomJQueryBuilder.prototype.buildDom = function () {

    jQuery.each(this.domConfigs, function (domObjectName, relevantConfig) {

        this.target[domObjectName] = this.createSimpleObject(relevantConfig);
        this.target[domObjectName].$ = this.getJQueryObject(relevantConfig);
        this.attachMethods(this.target[domObjectName], relevantConfig);
    }.bind(this));
};

/**
 * Returns the skeleton of the DOM object.
 *
 * @param {Object} config
 * @returns {Object}
 */
SearchUiDomJQueryBuilder.prototype.createSimpleObject = function (config) {

    return {
        selector: config.selector,
    };
};

/**
 * Returns the jQuery object
 *
 * @param config
 * @returns {*}
 */
SearchUiDomJQueryBuilder.prototype.getJQueryObject = function (config) {

    if (typeof config.descendantOf !== 'undefined') {

        return this.target[config.descendantOf].$.find(config.selector);
    } else {

        return jQuery(config.selector);
    }
};

/**
 * Attach the configured methods to a specific DOM object
 *
 * @param domObject
 * @param config
 */
SearchUiDomJQueryBuilder.prototype.attachMethods = function (domObject, config) {

    if (typeof config.methods !== 'undefined') {

        config.methods.forEach(function (method) {
            var typeFunctionName = method.type + 'Type';
            if (typeof this[typeFunctionName] === 'function') {
                this[typeFunctionName].call(domObject, method, this.simpleCallType);
            }
        }.bind(this));
    }
};

SearchUiDomJQueryBuilder.prototype.simpleCallType = function (methodConfig) {

    if (methodConfig.methodName && methodConfig.libraryMethodName) {

        this[methodConfig.methodName] = function () {

            var libraryMethodParam;
            if (typeof methodConfig.libraryMethodParam !== 'undefined') {

                libraryMethodParam = [methodConfig.libraryMethodParam];
            } else {

                libraryMethodParam = arguments;
            }
            return this.$[methodConfig.libraryMethodName].apply(this.$, libraryMethodParam);
        }.bind(this);
    }
};

SearchUiDomJQueryBuilder.prototype.showAndHideType = function (methodConfig, simpleCallType) {

    [{
        methodName: 'show',
        libraryMethodName: 'removeClass',
        libraryMethodParam: 'wh-hide',
    }, {
        methodName: 'hide',
        libraryMethodName: 'addClass',
        libraryMethodParam: 'wh-hide',
    }].map(simpleCallType.bind(this));
};

SearchUiDomJQueryBuilder.prototype.toggleClassType = function (methodConfig, simpleCallType) {

    if (methodConfig.addClassMethodName && methodConfig.removeClassMethodName && methodConfig.className) {

        [{
            methodName: methodConfig.addClassMethodName,
            libraryMethodName: 'addClass',
            libraryMethodParam: methodConfig.className,
        }, {
            methodName: methodConfig.removeClassMethodName,
            libraryMethodName: 'removeClass',
            libraryMethodParam: methodConfig.className,
        }].map(simpleCallType.bind(this));
    }
};

SearchUiDomJQueryBuilder.prototype.bindAndUnBindDomEventsType = function (methodConfig, simpleCallType) {

    [{
        methodName: 'off',
        libraryMethodName: 'off',
    }, {
        methodName: 'on',
        libraryMethodName: 'on',
    }].map(simpleCallType.bind(this));
};

SearchUiDomJQueryBuilder.prototype.extendHeightWithType = function () {

    this.extendHeightWith = function (heightDifference) {

        var height = this.$.parent().height();
        this.$.height(height + heightDifference);
    }.bind(this);
};

export default SearchUiDomJQueryBuilder;
